import { apiFetch } from "./client";
import type { SystemStatus, TaskStatus } from "./types";

// Live health of every dependency (database, Redis, Celery workers,
// Elasticsearch, embedding, LLM, Moodle, transcription). Always 200; each
// check has a 5s limit, so this can take ~5–6s. Poll every 30–60s, no faster.
export function getSystemStatus() {
  return apiFetch<SystemStatus>("/admin/status");
}

// State of a task id returned by a queued trigger. Celery reports PENDING
// both for queued and for unknown/expired ids (results expire after 24h).
// 503 means the result backend is down.
export function getTask(taskId: string) {
  return apiFetch<TaskStatus>(`/tasks/${encodeURIComponent(taskId)}`);
}
